import { render, staticRenderFns } from "./DownloadTaxProfiles.vue?vue&type=template&id=3cebed97"
import script from "./DownloadTaxProfiles.vue?vue&type=script&lang=js"
export * from "./DownloadTaxProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports